/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CurrencySchemaEntryCreate } from '../models/CurrencySchemaEntryCreate';
import type { CustomSchemaCreate } from '../models/CustomSchemaCreate';
import type { CustomSchemaEntryPatch } from '../models/CustomSchemaEntryPatch';
import type { CustomSchemaOut } from '../models/CustomSchemaOut';
import type { CustomSchemaPatch } from '../models/CustomSchemaPatch';
import type { CustomSchemaValueCreate } from '../models/CustomSchemaValueCreate';
import type { CustomSchemaValueOut } from '../models/CustomSchemaValueOut';
import type { DateTimeSchemaEntryCreate } from '../models/DateTimeSchemaEntryCreate';
import type { ItemDataImportResult } from '../models/ItemDataImportResult';
import type { ItemDataIn } from '../models/ItemDataIn';
import type { ItemDataOut } from '../models/ItemDataOut';
import type { NoConfigSchemaEntryCreate } from '../models/NoConfigSchemaEntryCreate';
import type { NoFieldSchemaEntryCreate } from '../models/NoFieldSchemaEntryCreate';
import type { ObjectSchemaOut } from '../models/ObjectSchemaOut';
import type { PasswordSchemaEntryCreate } from '../models/PasswordSchemaEntryCreate';
import type { ReorderCustomSchemaEntries } from '../models/ReorderCustomSchemaEntries';
import type { ReorderObjectSchemas } from '../models/ReorderObjectSchemas';
import type { SchemaImportResult } from '../models/SchemaImportResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SchemasService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Object Schemas
     * List all schemas applied to an object, with recursively flattened entries and values.
     * @returns ObjectSchemaOut Successful Response
     * @throws ApiError
     */
    public getObjectSchemasApiV1SchemasObjectObjectIdGet({
        objectId,
    }: {
        objectId: number,
    }): CancelablePromise<Array<ObjectSchemaOut>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/schemas/object/{object_id}',
            path: {
                'object_id': objectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Object Data
     * Export the values of an object (free fields and applied schemas) as OpenInv value objects.
     * The `schemas` part is keyed like the schema export `/{schema_id}/openapi`.
     * @returns ItemDataOut Successful Response
     * @throws ApiError
     */
    public exportObjectDataApiV1SchemasObjectObjectIdOpeninvGet({
        objectId,
    }: {
        objectId: number,
    }): CancelablePromise<ItemDataOut> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/schemas/object/{object_id}/openinv',
            path: {
                'object_id': objectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import Object Data
     * Replace the values an exported document names. Fields are matched by name, schemas and entries by their export key.
     * Unknown names and values of another type are left out and reported in `ignored`, an invalid value is a `422` and writes nothing.
     * @returns ItemDataImportResult Successful Response
     * @throws ApiError
     */
    public importObjectDataApiV1SchemasObjectObjectIdOpeninvPut({
        objectId,
        requestBody,
    }: {
        objectId: number,
        requestBody: ItemDataIn,
    }): CancelablePromise<ItemDataImportResult> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/schemas/object/{object_id}/openinv',
            path: {
                'object_id': objectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Apply Schema To Object
     * Link a schema to an object.
     * @returns ObjectSchemaOut Successful Response
     * @throws ApiError
     */
    public applySchemaToObjectApiV1SchemasObjectObjectIdApplySchemaIdPost({
        objectId,
        schemaId,
    }: {
        objectId: number,
        schemaId: string,
    }): CancelablePromise<ObjectSchemaOut> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/schemas/object/{object_id}/apply/{schema_id}',
            path: {
                'object_id': objectId,
                'schema_id': schemaId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remove Schema From Object
     * Unlink a schema from an object (values for that schema's entries are also deleted).
     * @returns any Successful Response
     * @throws ApiError
     */
    public removeSchemaFromObjectApiV1SchemasObjectObjectIdRemoveSchemaIdDelete({
        objectId,
        schemaId,
    }: {
        objectId: number,
        schemaId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/schemas/object/{object_id}/remove/{schema_id}',
            path: {
                'object_id': objectId,
                'schema_id': schemaId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reorder Object Schemas
     * Reorder schemas on an object.
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderObjectSchemasApiV1SchemasObjectObjectIdOrderPut({
        objectId,
        requestBody,
    }: {
        objectId: number,
        requestBody: ReorderObjectSchemas,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/schemas/object/{object_id}/order',
            path: {
                'object_id': objectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Schema Field Value
     * Set or update a single value for a non-multi schema entry.
     * @returns CustomSchemaValueOut Successful Response
     * @throws ApiError
     */
    public setSchemaFieldValueApiV1SchemasObjectObjectIdValuesEntryIdPut({
        objectId,
        entryId,
        requestBody,
    }: {
        objectId: number,
        entryId: string,
        requestBody: CustomSchemaValueCreate,
    }): CancelablePromise<CustomSchemaValueOut> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/schemas/object/{object_id}/values/{entry_id}',
            path: {
                'object_id': objectId,
                'entry_id': entryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Schema Field Value
     * Append a value for a multi-value schema entry.
     * @returns CustomSchemaValueOut Successful Response
     * @throws ApiError
     */
    public addSchemaFieldValueApiV1SchemasObjectObjectIdValuesEntryIdPost({
        objectId,
        entryId,
        requestBody,
    }: {
        objectId: number,
        entryId: string,
        requestBody: CustomSchemaValueCreate,
    }): CancelablePromise<CustomSchemaValueOut> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/schemas/object/{object_id}/values/{entry_id}',
            path: {
                'object_id': objectId,
                'entry_id': entryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reorder Schema Field Values
     * Reorder multi values of a schema field entry.
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderSchemaFieldValuesApiV1SchemasObjectObjectIdValuesEntryIdOrderPut({
        objectId,
        entryId,
        requestBody,
    }: {
        objectId: number,
        entryId: string,
        requestBody: ReorderCustomSchemaEntries,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/schemas/object/{object_id}/values/{entry_id}/order',
            path: {
                'object_id': objectId,
                'entry_id': entryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Schema Field Value
     * Delete a specific value row.
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteSchemaFieldValueApiV1SchemasObjectObjectIdValuesEntryIdValueIdDelete({
        objectId,
        entryId,
        valueId,
    }: {
        objectId: number,
        entryId: string,
        valueId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/schemas/object/{object_id}/values/{entry_id}/{value_id}',
            path: {
                'object_id': objectId,
                'entry_id': entryId,
                'value_id': valueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Schemas
     * List all visible schemas: global (owner IS NULL) plus the requesting user's private schemas.
     * @returns CustomSchemaOut Successful Response
     * @throws ApiError
     */
    public listSchemasApiV1SchemasGet(): CancelablePromise<Array<CustomSchemaOut>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/schemas/',
        });
    }
    /**
     * Create Schema
     * Create a new schema.
     * @returns CustomSchemaOut Successful Response
     * @throws ApiError
     */
    public createSchemaApiV1SchemasPost({
        requestBody,
    }: {
        requestBody: CustomSchemaCreate,
    }): CancelablePromise<CustomSchemaOut> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/schemas/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import Schemas
     * Create the schemas of an OpenAPI document of OpenInv definitions (the output of `/{schema_id}/openapi`).
     * A name that is taken gets ` (2)`, ` (3)`, … (`renamed`), what cannot be read is left out and named in `ignored`.
     * Declared above the `/{schema_id}` routes, so the literal segment is not read as an id.
     * @returns SchemaImportResult Successful Response
     * @throws ApiError
     */
    public importSchemasApiV1SchemasImportPost({
        requestBody,
        visibility = 'private',
    }: {
        requestBody: Record<string, any>,
        visibility?: 'global' | 'private',
    }): CancelablePromise<SchemaImportResult> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/schemas/import',
            query: {
                'visibility': visibility,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Openinv Definitions
     * The OpenInv vocabulary: the JSON Schema definitions of the values that the schema export is made of.
     * Declared above the `/{schema_id}` routes, so the literal segment is not read as an id.
     * @returns any Successful Response
     * @throws ApiError
     */
    public getOpeninvDefinitionsApiV1SchemasOpeninvJsonGet(): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/schemas/openinv.json',
        });
    }
    /**
     * Get Schema
     * Get a schema with all its entries.
     * @returns CustomSchemaOut Successful Response
     * @throws ApiError
     */
    public getSchemaApiV1SchemasSchemaIdGet({
        schemaId,
    }: {
        schemaId: string,
    }): CancelablePromise<CustomSchemaOut> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/schemas/{schema_id}',
            path: {
                'schema_id': schemaId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Schema
     * Rename / update description of a schema.
     * @returns CustomSchemaOut Successful Response
     * @throws ApiError
     */
    public updateSchemaApiV1SchemasSchemaIdPatch({
        schemaId,
        requestBody,
    }: {
        schemaId: string,
        requestBody: CustomSchemaPatch,
    }): CancelablePromise<CustomSchemaOut> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/schemas/{schema_id}',
            path: {
                'schema_id': schemaId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Schema
     * Delete a schema (cascade removes all links, entries, and values).
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteSchemaApiV1SchemasSchemaIdDelete({
        schemaId,
    }: {
        schemaId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/schemas/{schema_id}',
            path: {
                'schema_id': schemaId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Schema Json Schema
     * Export a schema (recursing into any sub-schemas) as an OpenAPI 3.1 document of OpenInv definitions,
     * usable in generic OpenAPI editors and as the exchange format between inventory apps.
     * @returns any Successful Response
     * @throws ApiError
     */
    public getSchemaJsonSchemaApiV1SchemasSchemaIdOpenapiGet({
        schemaId,
    }: {
        schemaId: string,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/schemas/{schema_id}/openapi',
            path: {
                'schema_id': schemaId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reorder Schema Entries
     * Reorder entries in a schema.
     * @returns any Successful Response
     * @throws ApiError
     */
    public reorderSchemaEntriesApiV1SchemasSchemaIdEntriesOrderPut({
        schemaId,
        requestBody,
    }: {
        schemaId: string,
        requestBody: ReorderCustomSchemaEntries,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/schemas/{schema_id}/entries/order',
            path: {
                'schema_id': schemaId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Schema Entry
     * Add an entry to a schema (field or schema_ref).
     * @returns CustomSchemaOut Successful Response
     * @throws ApiError
     */
    public addSchemaEntryApiV1SchemasSchemaIdEntriesPost({
        schemaId,
        requestBody,
    }: {
        schemaId: string,
        requestBody: (NoFieldSchemaEntryCreate | NoConfigSchemaEntryCreate | DateTimeSchemaEntryCreate | CurrencySchemaEntryCreate | PasswordSchemaEntryCreate),
    }): CancelablePromise<CustomSchemaOut> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/schemas/{schema_id}/entries',
            path: {
                'schema_id': schemaId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Schema Entry
     * Update an entry in a schema.
     * @returns CustomSchemaOut Successful Response
     * @throws ApiError
     */
    public updateSchemaEntryApiV1SchemasSchemaIdEntriesEntryIdPatch({
        schemaId,
        entryId,
        requestBody,
    }: {
        schemaId: string,
        entryId: string,
        requestBody: CustomSchemaEntryPatch,
    }): CancelablePromise<CustomSchemaOut> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/v1/schemas/{schema_id}/entries/{entry_id}',
            path: {
                'schema_id': schemaId,
                'entry_id': entryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Schema Entry
     * Delete an entry from a schema.
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteSchemaEntryApiV1SchemasSchemaIdEntriesEntryIdDelete({
        schemaId,
        entryId,
    }: {
        schemaId: string,
        entryId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/schemas/{schema_id}/entries/{entry_id}',
            path: {
                'schema_id': schemaId,
                'entry_id': entryId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
